import PropTypes from "prop-types";

/**
 * Location/Coordinate Shape
 * Shape for geographic location data with coordinates
 *
 * @typedef {Object} Location
 * @property {number} lat - Latitude coordinate (required)
 * @property {number} lng - Longitude coordinate (required)
 * @property {string} [name] - Location name
 * @property {string} [address] - Full address text
 */
export const locationShape = PropTypes.shape({
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  name: PropTypes.string,
  address: PropTypes.string,
});
